import React from "react";
// UI Framework
import AddIcon from "@mui/icons-material/Add";
// Common Components
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { Modal } from "src/Components";
// Local Components
import ExcludedCalculationSymbolModal from "./ExcludedCalculationSymbolModal";
// Services
import { getExcludedCalculationSymbolsTable } from "src/Requests/imePortfolio";
// Types
import {
  IUserPositionSummarySearchParams,
  IUserPositionSummaryTableReport,
} from "src/Interfaces/imePortfolio";
import PortfoTableSection from "./PortfoTableSection";

interface IProps {
  searchParams: IUserPositionSummarySearchParams;
  totalRefreshFlag: boolean;
  forceUpdateHandler: () => void;
}

const UserExcludedCalculationSymbolsTable = ({
  searchParams,
  totalRefreshFlag,
  forceUpdateHandler,
}: IProps) => {
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [refresh, setRefresh] = React.useState(false);

  return (
    <PortfoTableSection
      title="نمادهای خارج از محاسبات"
      action={
        <div
          className={`flex items-center justify-center transition-all w-5 h-5 rounded-full ${searchParams.userId ? "hover:bg-green-600 bg-green-700 cursor-pointer" : "bg-gray-500 cursor-not-allowed"}`}
          onClick={() => {
            if (!searchParams.userId) return;
            setIsModalOpen(true);
          }}
        >
          <AddIcon fontSize="small" className="text-white transition-all" />
        </div>
      }
    >
      {isModalOpen ? (
        <Modal
          UI={
            <ExcludedCalculationSymbolModal
              searchParams={searchParams}
              setRefresh={setRefresh}
            />
          }
          onClose={() => {
            setIsModalOpen(false);
            forceUpdateHandler();
          }}
          modalBoxClassName="!min-h-min"
        />
      ) : null}

      <TableTemplate<
        IUserPositionSummarySearchParams,
        IUserPositionSummaryTableReport
      >
        getDataTable={getExcludedCalculationSymbolsTable}
        tableWrapperClassname="w-full justify-start"
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            sortingType={sortingType}
            setSortingType={setSortingType}
            tableBoxClassName="!mx-0"
            tableHeaderClassName="!bg-sky-50 hover:!bg-sky-100"
            onAction={onAction}
            refreshFlag={refresh || totalRefreshFlag}
          />
        )}
        withSort
        searchParameters={searchParams}
        showIsLoading={false}
      />
    </PortfoTableSection>
  );
};

export default UserExcludedCalculationSymbolsTable;
